import "core-js/modules/es.array.concat.js";
import React from 'react';
import PropTypes from 'prop-types';
import { translateFieldName } from '../utils/helpers';
import { LANG } from '../utils/constant';
import BreadCrumbItem from './BreadCrumbItem';

var BreadCrumbSingleProduct = function BreadCrumbSingleProduct(_ref) {
  var product = _ref.product;
  var productName = product[translateFieldName('code')];
  var product_sscategories = product.sub_sub_categories;
  var subSubCategory = product_sscategories.length > 0 ? product_sscategories[0] : undefined;
  var subCategory = subSubCategory === null || subSubCategory === void 0 ? void 0 : subSubCategory.sub_category;
  var category = subCategory === null || subCategory === void 0 ? void 0 : subCategory.category;
  var breadCrumbPrefix = "/".concat(LANG, "/shop/#");
  return /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-12 path d-flex"
  }, /*#__PURE__*/React.createElement("div", {
    className: "breadcrumb-home"
  }, /*#__PURE__*/React.createElement("a", {
    href: "/".concat(LANG, "/")
  }, /*#__PURE__*/React.createElement("i", {
    className: "fa fa-home fa-1-5x main-txt",
    "aria-hidden": "true"
  }))), category && /*#__PURE__*/React.createElement(BreadCrumbItem, {
    link: "".concat(breadCrumbPrefix, "/category/").concat(category.id),
    name: category[translateFieldName('name')],
    insideRouter: false
  }), category && subCategory && /*#__PURE__*/React.createElement(BreadCrumbItem, {
    link: "".concat(breadCrumbPrefix, "/category/").concat(category.id, "+").concat(subCategory.id),
    name: subCategory[translateFieldName('name')],
    insideRouter: false
  }), category && subCategory && subSubCategory && /*#__PURE__*/React.createElement(BreadCrumbItem, {
    link: "".concat(breadCrumbPrefix, "/category/").concat(category.id, "+").concat(subCategory.id, "+").concat(subSubCategory.id),
    name: subSubCategory[translateFieldName('name')],
    insideRouter: false
  }), /*#__PURE__*/React.createElement(BreadCrumbItem, {
    name: productName,
    insideRouter: false
  })));
};

BreadCrumbSingleProduct.propTypes = {
  product: PropTypes.object
};
export default BreadCrumbSingleProduct;